let windowObjectReference: Window | null = null
const dashboardUrl = process.env.REACT_APP_DASHBOARD_URL

export default function useLoginPopup() {
  return (nextUrl?: string) => {
    window.removeEventListener("message", receiveMessage)

    const popupWidth = 500
    const popupHeight = 700

    const dualScreenLeft = window.screenLeft || 0
    const dualScreenTop = window.screenTop || 0

    const width = window.innerWidth || document.documentElement.clientWidth
    const height = window.innerHeight || document.documentElement.clientHeight

    const left = ((width / 2) - (popupWidth / 2)) + dualScreenLeft
    const top = ((height / 2) - (popupHeight / 2)) + dualScreenTop

    let extraParams = ""
    if (nextUrl) {
      extraParams += `&nextUrl=${nextUrl}`
    }

    if (windowObjectReference === null || windowObjectReference.closed) {
      try {
        // @ts-ignore
        gtag("event", "conversion", {"send_to": "AW-502527264/lFp3CJ27t_UCEKDqz-8B"});
      } catch (e) {
        console.error(e)
      }

      try {
        //@ts-ignore
        analytics.track("homepage_to_dashboard_conversion")
      } catch (error) {}

      windowObjectReference = window.open(`${dashboardUrl}/oauth2/authorization/google?popup=true${extraParams}`, "google",
        `toolbar=no, menubar=no, width=${popupWidth}, height=${popupHeight}, top=${top}, left=${left}`)
    } else {
      windowObjectReference.focus()
    }

    window.addEventListener("message", receiveMessage, false)
  }
}

function receiveMessage(event: MessageEvent) {
  const origin = event.origin
  if (!origin.includes("hackle.io") && !origin.includes("hackledev.com")) {
    return
  }

  const { data } = event
  if (data.loginSuccess) {
    if (data.nextUrl) {
      window.location.href = `${data.nextUrl}`
    } else {
      window.location.href = `${dashboardUrl}`
    }
  }
}
